export default __webpack_public_path__ + "static/media/Selfielocation_smeatons.97774126.png";